<template>
	<v-row justify="center" v-if="computedIsAdmin">
		<v-dialog v-model="dialog" persistent max-width="600" >
			<template v-slot:activator="{ on, attrs }">
				<v-btn color="blue" icon large 
					v-if="$vuetify.breakpoint.smAndUp"
					:disabled="reserva.status_agenda=='NEGADO'" 
					v-on="on" >
					<v-icon> mdi-checkbox-marked-circle </v-icon>
				</v-btn>
				<v-btn v-if="$vuetify.breakpoint.xsOnly" 
					v-on="on" v-bind="attrs" 
					depressed color="blue" 
					:disabled="reserva.status_agenda!='PENDENTE'">
					<span class="white--text"> Aprovar</span>
				</v-btn>
			</template>
			<div>
				<v-stepper v-model="e1">
					<v-stepper-header>
						<v-stepper-step :complete="e1 > 1" step="1">
							Detalhes
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="e1 > 2" step="2">
							Justificativa
						</v-stepper-step>
					</v-stepper-header>
					
					<v-stepper-items>
						<v-stepper-content step="1">
							<v-card class="mb-6 pa-3" color="#E8F8F5">
								<v-card-text>
									<div>
										<div> <b>ID:</b> #{{reserva.id}}</div>
										<div> <b>Contexto: {{((reserva.get_sala||{}).get_contexto||{}).descricao || 'Nenhum Contexto Vinculado'}}</b></div>
										<div> <b>Turma:</b> {{reserva.codturma}}</div>
										<div> <b>Solicitante:</b> {{reserva.solicitante}}</div>
										<div> <b>Laboratório:</b> {{reserva.get_sala.sala}}</div>
										<div> <b>Finalidade:</b> {{reserva.get_finalidade.descricao}}</div>
										<div> <b>Data:</b> {{reserva.get_formatted_data}} - {{reserva.start}} às {{reserva.end}}</div>
										<div> <b>Título da prática:</b> {{reserva.titulo_aula}}</div>
										<div> <b>Curso:</b> {{reserva.curso}}</div>
										<div> <b>Disciplina:</b> {{reserva.disciplina}}</div>
										<div> <b>Status: <span :class="getColor(reserva.status_agenda)">{{reserva.status_agenda}}</span></b></div>
										
										<v-divider class="my-2"></v-divider>
										
										<div v-if="reserva.file_protocolo_pratica || reserva.file_reagentes_equipamentos">
											<h4>Arquivos</h4>
											<v-btn v-if="reserva.file_protocolo_pratica"
												@click.stop="downloadFile(get_base_url_backend+reserva.file_protocolo_pratica)"
												color="blue" class="mr-1 mt-1 white--text"
												:small="$vuetify.breakpoint.xsOnly">
												Anexo <v-icon right dark> mdi-cloud-download </v-icon>
											</v-btn>
											
											<v-btn v-if="reserva.file_reagentes_equipamentos" 
												@click.stop="downloadFile(get_base_url_backend+reserva.file_reagentes_equipamentos)"
												color="blue" class="mr-1 mt-1 white--text" 
												:small="$vuetify.breakpoint.xsOnly">
												Lista de Materiais <v-icon right dark> mdi-cloud-download </v-icon>
											</v-btn>
										</div>
									</div>
								</v-card-text>
							</v-card>
							<v-btn color="primary" @click="aprovarStatus()" 
								:small="$vuetify.breakpoint.xsOnly" class="mr-1"
								v-if="reserva.status_agenda != 'APROVADO'"
								>
								Aprovar
							</v-btn>
							
							<v-btn text @click="e1 = 2" color="error" :small="$vuetify.breakpoint.xsOnly" class="mr-1">
								Reprovar
							</v-btn>
							
							<v-btn text color="primary" @click="dialog = false" :small="$vuetify.breakpoint.xsOnly" class="mr-1">
								Fechar
							</v-btn>
						</v-stepper-content>
						
						<v-stepper-content step="2">
              
							<v-card class="mb-6 pa-3" color="#E8F8F5">
								<v-card-text>
									Insira abaixo uma justificativa para a reprovação do agendamento, com um mínimo de 10 caracteres.
									<v-text-field v-model="reserva.status_ressalva"
										color="primary"
										label="Justifica da reprovação"
										placeholder="Justificativa"
										loading>
										<template v-slot:progress>
											<v-progress-linear v-if="custom" :value="progress" :color="color" absolute height="7" ></v-progress-linear>
										</template>
									</v-text-field>
								</v-card-text>
							</v-card>
							<v-btn :disabled="progress < 100" color="error" @click="reprovarStatus()" :small="$vuetify.breakpoint.xsOnly" class="mr-1">
								Reprovar
							</v-btn>
							
							<v-btn text @click="e1 = 1" :small="$vuetify.breakpoint.xsOnly">
								Voltar
							</v-btn>		
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</div>
		</v-dialog>
	</v-row>
</template>

<script>
import BackendConfigService from '@/services/configs/backendConfigService'

export default {
	name: 'Aprovacao',
	props:{
		reserva:{
			required:true
		}
	},
	data () {
		return {
			dialog: false,
			e1: 1,
			custom: true,
		}        
	},
	computed:{
		progress(){
			let length = Math.min(100, (this.reserva.status_ressalva || '').length *10)
			return length
		},
		color(){
			return ['error','warning','success'][Math.floor(this.progress/40)]
		},
		get_base_url_backend(){
			const backend = new BackendConfigService()
			const url = backend.get_base_url_backend()
			console.log(url)
			return url
		},
		computedIsAdmin(){
			return this.$store.globalStore.getters.isAdmin
		}
	},
	methods:{
		getColor(status) {
			let cor = ''
			switch(status){
				case 'PENDENTE': cor = 'warning--text'; break;
				case 'NEGADO': cor = 'error--text'; break;
				case 'APROVADO': cor = 'success--text'; break;
				default: cor = 'black--text';
			}
			return cor
		},	
		aprovarStatus(){
			this.reserva.status_agenda = 'APROVADO' 
			this.dialog = false
			this.$emit('aprovado', this.reserva)
		},		
		reprovarStatus(){
			this.reserva.status_agenda = 'NEGADO' 
			this.dialog = false
			this.$emit('aprovado', this.reserva)
		},		
		downloadFile(url){
			window.open(url)
		}
	},
	mounted(){
	}
}
</script>